<template>
  <div>
    <b-row>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="Name" isMandatory
          :inputLabel="$t('common.email.email_address_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_address_name')"
        :inputValue="Name">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="Email" isMandatory
          :inputLabel="$t('common.email.email_address')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_address')"
        :inputValue="Email">
        </form-read-group-label-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"

export default {
  name: "EmailAddressForm",
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    "form-write-group-label-input": formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    Name: {
      get () {
        return this.inputValue.Name
      },
      set (val) {
        this.inputValue = {
          Name: val,
          Email: this.inputValue.Email
        }
      }
    },
    Email: {
      get () {
        return this.inputValue.Email
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          Email: val
        }
      }
    }
  },
  data() {
  },
  created() {
  },
  methods: {
  }
}
</script>
